import { graphql } from "react-relay";

export const AddAccountGroupMutation = graphql`
  mutation AddAccountGroupMutation(
    $input: AddAccountGroupInput!
    $connections: [ID!]!
  ) {
    addAccountGroup(input: $input) {
      group
        @appendNode(
          connections: $connections
          edgeTypeName: "AccountGroupEdge"
        ) {
        dynamicFilter
        id
        name
        provider
        regions
        uuid
      }
    }
  }
`;
